import styled from "styled-components";

export const OverlayMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9998;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: ${({ show }) => (show ? "1" : "0")};
  pointer-events: ${({ show }) => (show ? "auto" : "none")};
  transition: opacity 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;

  #overlay-message-box {
    display: flex;
    position: relative;
    width: fit-content;
    background-color: ${({ theme }) => theme.backgroundDark};
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
    height: 100px;
  }

  #overlay-message {
    display: flex;
    gap: 16px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1.5em;
    text-align: center;
    color: ${({ theme }) => theme.editor.textLight};
    font-family: ${({ theme }) => theme.fontMedium};
    font-size: 18px;
  }

  @media only screen and (max-height: 500px) {
    #overlay-message > img {
      display: none;
    }
  }
`;
